import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export default function WidgetCardSkeleton() {
  return (
    <Card className="w-full max-w-2xl">
      {/* Header with title and icon */}
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-4">
        <Skeleton className="h-6 w-20" />
        <Skeleton className="size-5" />
      </CardHeader>

      {/* Main content area */}
      <CardContent className="px-6">
        <div className="space-y-4">
          <div className="flex items-center space-x-4">
            <Skeleton className="size-12 rounded-full" />
            <div className="flex-1 space-y-2">
              <Skeleton className="h-4 w-3/4" />
              <Skeleton className="h-3 w-1/2" />
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <Skeleton className="size-12 rounded-full" />
            <div className="flex-1 space-y-2">
              <Skeleton className="h-4 w-2/3" />
              <Skeleton className="h-3 w-1/3" />
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <Skeleton className="size-12 rounded-full" />
            <div className="flex-1 space-y-2">
              <Skeleton className="h-4 w-4/5" />
              <Skeleton className="h-3 w-2/5" />
            </div>
          </div>

          {/* Additional placeholder rows */}
          <div className="space-y-3 pt-4">
            <Skeleton className="h-3 w-full" />
            <Skeleton className="h-3 w-5/6" />
            <Skeleton className="h-3 w-4/6" />
          </div>
        </div>
      </CardContent>

      {/* Footer with View All button */}
      <CardFooter className="flex justify-center pt-4">
        <div className="flex items-center space-x-2">
          <Skeleton className="h-4 w-16" />
          <Skeleton className="size-4 rounded-full" />
        </div>
      </CardFooter>
    </Card>
  );
}
